import React from 'react';
import * as Styled from './style.js';

function LGPD() {

  const navLinks = [
    { href: "#introducao", text: "Introdução" },
    { href: "#lgpd", text: "Tratamento de Dados Pessoais (LGPD)" },
    { href: "#deveres-renovera", text: "Nossos Deveres" },
    { href: "#principios", text: "Princípios de Tratamento" },
    { href: "#centro-controle-privacidade", text: "Centro de Controle de Privacidade" },
  ];


  const documents = [
    { name: "AVISO DE PRIVACIDADE - RH", path: "/documentos/aviso-privacidade-rh-renovera.pdf" },
    { name: "AVISO DE PRIVACIDADE - Produtos", path: "/documentos/aviso-privacidade-produtos-renovera.pdf" },
    { name: "AVISO DE PRIVACIDADE - Financeiro", path: "/documentos/aviso-privacidade-financeiro-renovera.pdf" },
    { name: "AVISO DE PRIVACIDADE - Comercial", path: "/documentos/aviso-privacidade-comercial-renovera.pdf" },
    { name: "AVISO DE PRIVACIDADE - Administrativo", path: "/documentos/aviso-privacidade-administrativo-renovera.pdf" },
    { name: "Cartilha de Boas Práticas e Recomendações", path: "/documentos/cartilha-boas-praticas-renovera.pdf" },
    { name: "CANAL DE ATENDIMENTO", path: "/documentos/canal-de-atendimento.pdf" },
    { name: "ENCARREGADO DE DADOS", path: "/documentos/encarregado-de-dados.pdf" },
    { name: "INFORMAÇÕES GERAIS", path: "/documentos/informacoes-gerais.pdf" },
  ];

  return (
    <Styled.PageContainer>

      <Styled.HeroSection>
        <Styled.MaxWidthContainer>
          <Styled.HeroGrid>
            <Styled.HeroContent>
              <Styled.Tag>LGPD • Segurança da Informação</Styled.Tag>
              <h1>Nosso Compromisso com a Proteção de Dados</h1>
              <p>Entenda como a Renovera se dedica a proteger os dados de clientes, parceiros e integradores, seguindo as melhores práticas de privacidade.</p>
              <Styled.ButtonGroup>
                <Styled.PrimaryButton href="#conteudo">Leia sobre nossas práticas</Styled.PrimaryButton>
              </Styled.ButtonGroup>
            </Styled.HeroContent>
            <div>
              <Styled.PillarCard>
                <h3>Pilares de Tratamento</h3>
                <ul>
                  <Styled.PillarItem><p>Finalidade</p><p>Uso legítimo e específico.</p></Styled.PillarItem>
                  <Styled.PillarItem><p>Necessidade</p><p>Coleta mínima de dados.</p></Styled.PillarItem>
                  <Styled.PillarItem><p>Transparência</p><p>Titular sempre informado.</p></Styled.PillarItem>
                  <Styled.PillarItem><p>Segurança</p><p>Medidas técnicas e administrativas.</p></Styled.PillarItem>
                </ul>
                <Styled.ContactInfoBox>
                  Dúvidas sobre privacidade? <Styled.ContactLink href="/fale-conosco">Entre em contato conosco</Styled.ContactLink>.
                </Styled.ContactInfoBox>
              </Styled.PillarCard>
            </div>
          </Styled.HeroGrid>
        </Styled.MaxWidthContainer>
      </Styled.HeroSection>


      <Styled.SummarySection>
        <Styled.SummaryCard>
          <h2>O que você encontra nesta página</h2>
          <Styled.NavGrid>
            {navLinks.map(link => <Styled.NavItem key={link.href} href={link.href}>{link.text}</Styled.NavItem>)}
          </Styled.NavGrid>
        </Styled.SummaryCard>
      </Styled.SummarySection>


      <Styled.ContentSection id="conteudo">
        <Styled.ContentGrid>
          <Styled.Sidebar>
            <Styled.SidebarCard>
              <p>Navegação rápida</p>
              <ul>
                {navLinks.map(link => <li key={link.href}><a href={link.href}>{link.text}</a></li>)}
              </ul>
            </Styled.SidebarCard>
          </Styled.Sidebar>

          <Styled.MainContent>
            <section id="introducao">
              <h3>Introdução</h3>
              <p>Este guia descreve o compromisso da Renovera com a segurança da informação e a privacidade de dados, garantindo conformidade com a Lei Geral de Proteção de Dados (LGPD) e a proteção da integridade, confidencialidade e disponibilidade das informações.</p>
              <hr />
            </section>

            <section id="lgpd">
              <h3>Tratamento de Dados Pessoais (LGPD)</h3>
              <h4>O que são Dados Pessoais</h4>
              <p>Qualquer informação que identifique uma pessoa natural, como nome, CPF, RG, endereço, e-mail e telefone.</p>
              <h4>Dados Pessoais Sensíveis</h4>
              <p>Dados sobre origem racial/étnica, convicção religiosa, opinião política, saúde ou dados biométricos. A Renovera evita ao máximo a coleta deste tipo de dado, tratando-os com cuidado redobrado quando estritamente necessário.</p>
              <hr />
            </section>

            <section id="principios">
              <h3>Princípios de Tratamento</h3>
              <p>Todo tratamento de dados na Renovera segue os seguintes princípios:</p>
              <ul>
                <li><strong>Finalidade:</strong> utilizamos os dados apenas para fins específicos, legítimos e informados ao titular.</li>
                <li><strong>Adequação e Necessidade:</strong> coletamos apenas o mínimo de dados necessários para atingir a finalidade proposta.</li>
                <li><strong>Transparência:</strong> garantimos ao titular informações claras sobre como seus dados são tratados.</li>
                <li><strong>Segurança:</strong> aplicamos medidas técnicas e administrativas para prevenir acessos não autorizados e incidentes.</li>
              </ul>
              <hr />
            </section>

            <section id="deveres-renovera">
              <h3>Nossos Deveres</h3>
              <p>A Renovera se compromete a:</p>
              <ul>
                <li>Manter os dados seguros e protegidos.</li>
                <li>Utilizar as informações apenas para as finalidades para as quais foram coletadas.</li>
                <li>Não compartilhar dados com terceiros sem uma base legal ou consentimento.</li>
                <li>Garantir que os titulares possam exercer seus direitos, conforme previsto em lei.</li>
              </ul>
              <hr />
            </section>


            <section id="documentos">
              <h3>Centro de Controle de Privacidade</h3>
              <p>Entenda como suas informações pessoais são coletadas e usadas, e escolha o que você quer compartilhar</p>
              <Styled.DocumentGrid>
                {documents.map(doc => (
                  <Styled.DocumentCard key={doc.name} href={doc.path} download target="_blank" rel="noopener noreferrer">
                    <Styled.PdfIcon />
                    <span>{doc.name}</span>
                  </Styled.DocumentCard>
                ))}
              </Styled.DocumentGrid>
            </section>
          </Styled.MainContent>
        </Styled.ContentGrid>
      </Styled.ContentSection>
    </Styled.PageContainer>
  );
}

export default LGPD;